import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AboutUs } from './components/AboutUs';
import { WhyJoin } from './components/WhyJoin';
import { MasterclassCurriculum } from './components/MasterclassCurriculum';
import { CommissionCalculator } from './components/CommissionCalculator';
import { TechnologyAdvantage } from './components/TechnologyAdvantage';
import { Perks } from './components/Perks';
import { PlannerCommunity } from './components/PlannerCommunity';
import { HowItWorks } from './components/HowItWorks';
import { Urgency } from './components/Urgency';
import { CTA } from './components/CTA';
import { BetterTogether } from './components/BetterTogether';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <AboutUs data-id="element-3" />
      <WhyJoin data-id="element-4" />
      <MasterclassCurriculum data-id="element-5" />
      <CommissionCalculator data-id="element-6" />
      <TechnologyAdvantage data-id="element-7" />
      <Perks data-id="element-8" />
      <PlannerCommunity data-id="element-9" />
      <HowItWorks data-id="element-10" />
      <Urgency data-id="element-11" />
      <CTA data-id="element-12" />
      <BetterTogether data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}